import * as Sentry from "@sentry/react";
import type { MeQuery } from "generated/graphql";
import type { UserRole } from "@modules/authentication/roles";

type SentryUserSource = (MeQuery["me"] & { role?: UserRole }) | null | undefined;
const nameIdentifierClaim =
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier";
const emailClaim =
  "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress";

const readStringClaim = (value: unknown) =>
  typeof value === "string" && value.length > 0 ? value : undefined;

export function syncSentryUser(user?: SentryUserSource) {
  if (!user?.id && !user?.email) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: user.id ?? undefined,
    email: user.email ?? undefined,
    username: user.fullName ?? undefined,
  });
}

export function syncSentryUserFromClaims(claims: Record<string, unknown>) {
  const id = readStringClaim(claims.sub) ?? readStringClaim(claims[nameIdentifierClaim]);
  const email = readStringClaim(claims.email) ?? readStringClaim(claims[emailClaim]);

  if (!id && !email) {
    syncSentryUser(null);
    return;
  }

  Sentry.setUser({ id, email });
}
